import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Col, Row, Modal, Typography } from 'antd';
import { useParams, useLocation } from 'react-router-dom';
import { withRouter } from 'react-router';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { EVINE_BOOK_LESSON_INFO, EVINE_STUDY_DATA, GET_USER_LESSON_INFO } from 'src/operations/queries/getEvineLesson';
import { CREATE_USER_STUDY } from 'src/operations/mutations/userStudy';
import { GET_USER_STUDY_COMPLETE_LIST } from 'src/operations/queries/study';
import { useQueryProxy } from 'src/operations/proxy/user';
import Loading from 'src/components/common/Loading';
import {
  ListPage,
  VocaPage,
  ListenPage,
  QuizPage,
  ListenRepeatPage,
  ListenRepeatSTTPage,
  EssayPage,
  ListenWordPage,
  PassagePage,
} from 'src/components/Tool';
import { getCurrentToken } from 'src/utils';
import * as queries from 'src/operations/queries';
const { Title } = Typography;

const wordData = [
  {
    no: 1,
    eng: 'ant',
    kor: '개미',
    eng_audio: '/audio/Voca/ant.mp4',
  },
  {
    no: 2,
    eng: 'apple',
    kor: '사과',
    eng_audio: '/audio/Voca/apple.mp4',
  },
  {
    no: 3,
    eng: 'album',
    kor: '앨범',
    eng_audio: '/audio/Voca/album.mp4',
  },
  {
    no: 4,
    eng: 'bus',
    kor: '버스',
    eng_audio: '/audio/Voca/bus.mp4',
  },
  {
    no: 5,
    eng: 'bat',
    kor: '야구방망이',
    eng_audio: '/audio/Voca/bat.mp4',
  },
  {
    no: 6,
    eng: 'ball',
    kor: '공',
    eng_audio: '/audio/Voca/ball.mp4',
  },
  {
    no: 7,
    eng: 'cat',
    kor: '고양이',
    eng_audio: '/audio/Voca/cat.mp4',
  },
  {
    no: 8,
    eng: 'cup',
    kor: '컵',
    eng_audio: '/audio/Voca/cup.mp4',
  },
  {
    no: 9,
    eng: 'candy',
    kor: '캔디',
    eng_audio: '/audio/Voca/candy.mp4',
  },
];

const getUpdatedList = (quesData, all) => {
  for (let i = 0; i < quesData.length; i++) {
    let randDot = quesData[i]['eng'].trim();
    randDot = randDot.replace(/[<>\[\]]*/g, '');
    quesData[i]['qns'] = randDot.split(' ');
    quesData[i]['ans'] = randDot;
    const lenrandDot = Math.floor(randDot.replace(/\s*/g, '').length * 0.5);
    let last = 0;
    randDot = randDot
      .trim()
      .split('')
      .map((v) => {
        if (!v.match(/^[0-9a-zA-Z]+$/)) return v;
        if (all) return '⬤';
        if (Math.random() - 0.1 > 0.1 && last < lenrandDot) {
          last += 1;
          return v;
        } else {
          return '⬤';
        }
      })
      .join('');
    quesData[i]['ques'] = randDot;
    quesData[i]['eng_audio'] = quesData[i]['eng_audio'];
    quesData[i]['kor'] = quesData[i]['kor'];
  }

  return quesData;
};

const defaultData = getUpdatedList(wordData, false);

const titleData = {
  voca: 'Words',
  recording: 'Recording',
  sentence: 'Key Sentence',
  Essay: 'Essay',
};

const Manage = (props) => {
  const { type = 'voca', code = undefined } = useParams();
  const { state } = useLocation();

  const [indx, setIndx] = useState(1);
  const [activeB, setActiveB] = useState(false);
  const [dataSet, setDataset] = useState(false);
  const [bookInfo, setBookInfo] = useState(null);
  const [isBookInfo, setIsBookInfo] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [lessonActualData, setLessonActualData] = useState([]);
  const [lessonData, setLessonData] = useState([]);

  const [getBookInfo, { data: dataBookInfo, loading }] = useLazyQuery(GET_USER_LESSON_INFO, { fetchPolicy: 'no-cache' });
  const [getStudyData, { data: dataStudy, loading: loading2 }] = useLazyQuery(EVINE_STUDY_DATA, { fetchPolicy: 'no-cache' });

  const [createUserStudy] = useMutation(CREATE_USER_STUDY, {
    notifyOnNetworkStatusChange: true,
  });

  const token = getCurrentToken();
  const { data: userData } = useQueryProxy(queries.getUser.USER_ME, {
    variables: { token },
  });
  const { data: dataUserStudy } = useQuery(GET_USER_STUDY_COMPLETE_LIST, {
    variables: { user_lesson_idx: state?.user_lesson_idx },
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!isBookInfo && code && code !== 'all') {
      getBookInfo({
        variables: {
          user_lesson_idx: state?.user_lesson_idx,
        },
      });
      setIsBookInfo(true);
    } else if ((code && code === 'all') || !code) {
      setLessonData(defaultData);
      setLessonActualData(defaultData);
      setDataLoaded(true);
      if (props.onChangeTitle) {
        props.onChangeTitle(titleData[type]);
      }
    }

    if (dataBookInfo?.getUserLessonInfo) {
      let filteredLessonInfo = JSON.parse(JSON.stringify(dataBookInfo?.getUserLessonInfo));
      filteredLessonInfo['stage'] = filteredLessonInfo.stage.filter((f) => f.study_tool);
      setBookInfo(filteredLessonInfo);
      const isComplete = filteredLessonInfo.stage?.every((stageItem) => stageItem.is_complete);
      console.log('isComplete', isComplete);
      let newIndx = indx;
      if (!dataSet) {
        // is_complete가 false인 첫 번째 스테이지로 이동해서 학습하도록 한다.
        // (예: 1,2,3,4 스테이지 중 1,3이 완료되었다면 2 스테이지로 이동)
        const firstIncompleteIndex = filteredLessonInfo.stage.findIndex((stageItem) => !stageItem.is_complete);
        if (firstIncompleteIndex !== -1) {
          newIndx = firstIncompleteIndex + 1;
        } else {
          newIndx = filteredLessonInfo.stage.length;
        }
        if (!isComplete) {
          setIndx(newIndx);
        }

        setDataset(true);
      }
      if (props.onChangeTitle) {
        props.onChangeTitle(titleData[filteredLessonInfo?.book_lesson?.stage_group_code]);
        if (
          filteredLessonInfo?.book_lesson.stage_group_code === 'essay' ||
          filteredLessonInfo?.book_lesson.stage_group_code === 'recording'
        ) {
          props.onSetHideHeader(true);
        }
      }
      if (filteredLessonInfo?.book_lesson.stage_group_code !== 'recording') {
        getStudyData({
          variables: {
            lesson_code: code,
            study_tool_idx: filteredLessonInfo.stage[newIndx - 1].study_tool.idx,
          },
        });
      } else {
        setDataLoaded(true);
      }
    }
  }, [type, code, dataBookInfo, indx, isBookInfo, getBookInfo, getStudyData, props, dataSet]);

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  useEffect(() => {
    if (type === 'sentence' && indx === 3) {
      handleGoNext({}, true);
    }
  }, [indx, type]);
  useEffect(() => {
    if (dataStudy?.getStudyData) {
      setLessonActualData(JSON.parse(JSON.stringify(dataStudy?.getStudyData?.study_lang_data)));
      setLessonData(
        getUpdatedList(
          JSON.parse(JSON.stringify(dataStudy?.getStudyData?.study_lang_data)),
          bookInfo?.book_lesson.stage_group_code === 'voca',
        ),
      );
      setDataLoaded(true);
    }
  }, [dataStudy, bookInfo]);

  const handleGoBack = (v) => {
    handleUserStudySave(v, goBackCallback);
  };

  const updateNextCallback = useCallback(() => {
    setIndx((prev) => {
      let next = prev + 1;
      const stages = bookInfo?.stage || [];
      // 다음 스테이지가 이미 완료된 학습이라면 건너뛰고 그 다음 스테이지로 이동
      // (예: 3 스테이지가 이미 완료되었다면 4 스테이지로 이동해 학습)
      while (next < stages.length && stages[next - 1]?.is_complete) {
        next += 1;
      }
      return next;
    });
  }, [bookInfo]);

  const goBackCallback = useCallback(() => {
    props.history.goBack();
  }, [props.history]);

  const handleGoNext = (v, noPopup = false) => {
    if (noPopup) {
      if (indx < bookInfo.stage.length && type !== 'essay') {
        handleUserStudySave(v, updateNextCallback);
      } else {
        handleUserStudySave(v, goBackCallback);
      }
    } else if (indx < bookInfo.stage.length && type !== 'essay') {
      Modal.destroyAll();
      Modal.confirm({
        icon: null,
        title: 'Next',
        content: (
          <Title level={4}>
            {`${v.message ? `${v.message}` : ''}`}
            <br />
            {`Good job!, Let\'s go to next stage.`}
          </Title>
        ),
        onOk: () => handleUserStudySave(v, updateNextCallback),
      });
    } else {
      Modal.destroyAll();
      Modal.confirm({
        icon: null,
        title: 'Exit',
        content: (
          <Title level={4}>
            {`${v.message ? `${v.message}` : ''}`}
            <br />
            {v.exitMessage ? v.exitMessage : ` Are you sure you want to exit?`}
          </Title>
        ),
        onOk: () => handleUserStudySave(v, goBackCallback),
        okText: 'Yes',
        cancelText: 'No',
      });
    }
  };

  const handleChangeIndx = (i) => {
    setActiveB(false);
    setIndx(i);
  };
  const isSavingRef = useRef(false);
  const handleUserStudySave = useCallback(
    (studyData = null, c) => {
      if (studyData) {
        if (isSavingRef.current) {
          return;
        }
        isSavingRef.current = true;
        try {
          delete studyData['message'];
          delete studyData['exitMessage'];
          createUserStudy({
            variables: {
              user_study_input: {
                ...studyData,
                user_idx: parseInt(userData.me.idx),
                lesson_code: code,
                stage_no: bookInfo.stage[indx - 1]['no'],
                user_lesson_idx: state?.user_lesson_idx,
              },
            },
          }).then(
            () => {
              isSavingRef.current = false;
              if (c) {
                c();
              }
            },
            (err) => {
              isSavingRef.current = false;
              console.log(err);
            },
          );
          console.log();
        } catch (e) {
          isSavingRef.current = false;
          console.log(e);
        }
      }
    },
    [code, userData, state, createUserStudy, bookInfo, indx],
  );
  const handleSaveExit = (studyData) => {
    if (studyData) {
      createUserStudy({
        variables: {
          user_study_input: {
            ...studyData,
            user_idx: parseInt(userData.me.idx),
            lesson_code: code,
            stage_no: bookInfo.stage[indx - 1]['no'],
            user_lesson_idx: state?.user_lesson_idx,
            stat: 0,
          },
        },
      });
    }
  };
  const getSwitchableRoute = (val) => {
    switch (val) {
      case 'voca':
        switch (indx) {
          case 1:
            return <VocaPage title={titleData[type]} onClickGoback={handleGoBack} gotoNext={handleGoNext} data={lessonData} />;
          case 2:
            return (
              <QuizPage
                title={titleData[type]}
                onClickGoback={handleGoBack}
                gotoNext={handleGoNext}
                data={lessonData}
                handleSaveExit={handleSaveExit}
                dataUserStudy={dataUserStudy}
              />
            );
          case 3:
            return (
              <ListenPage
                title={titleData[type]}
                onClickGoback={handleGoBack}
                type="voca"
                data={lessonData}
                gotoNext={handleGoNext}
                listenStageType={2}
                handleSaveExit={handleSaveExit}
                dataUserStudy={dataUserStudy}
              />
            );
        }
        break;
      case 'sentence':
        switch (indx) {
          case 1:
            return <ListenRepeatPage title={titleData[type]} onClickGoback={handleGoBack} data={lessonData} gotoNext={handleGoNext} />;
          case 2:
            return (
              <ListenPage
                title={titleData[type]}
                onClickGoback={handleGoBack}
                type="sentence"
                gotoNext={handleGoNext}
                data={lessonData}
                listenStageType={1}
                handleSaveExit={handleSaveExit}
                dataUserStudy={dataUserStudy}
              />
            );
          case 3:
            return (
              <Col className="listen-wrapper" span={24} style={{ textAlign: 'left', margin: 0 }}>
                <Loading />
              </Col>
            );
          // case 3:
          //   return (
          //     <ListenRepeatAIPage
          //       curIndx={indx}
          //       onClickGoback={handleGoBack}
          //       type="sentence"
          //       gotoNext={handleGoNext}
          //       data={lessonData}
          //       listenStageType={1}
          //       lessonCode={code}
          //     />
          //   );
          case 4:
            return (
              <ListenWordPage
                title={titleData[type]}
                onClickGoback={handleGoBack}
                type="sentence"
                data={lessonData}
                gotoNext={handleGoNext}
                propsStageType={2}
                handleSaveExit={handleSaveExit}
                dataUserStudy={dataUserStudy}
              />
            );
        }
        break;
      case 'word':
        return <VocaPage onClickGoback={handleGoBack} data={lessonData} />;
      case 'quiz':
        return <QuizPage onClickGoback={handleGoBack} data={lessonData} />;
      case 'listen':
        return <ListenPage type="listen" onClickGoback={handleGoBack} data={lessonData} />;
      case 'listen-stt':
        return <ListenRepeatSTTPage lessonCode={code} onClickGoback={handleGoBack} data={lessonData} />;
      case 'recording':
        return (
          <PassagePage
            data={lessonData}
            code={code}
            userLessonIdx={state?.user_lesson_idx || null}
            userData={userData?.me}
            onClickGoback={handleGoBack}
            gotoNext={handleGoNext}
          />
        );
      case 'listen-repeat':
        return <ListenRepeatPage onClickGoback={handleGoBack} data={lessonData} />;
      case 'translate':
        return <ListenPage onClickGoback={handleGoBack} data={lessonData} listenStageType={2} />;
      case 'translate-word':
        return <ListenWordPage onClickGoback={handleGoBack} data={lessonData} propsStageType={1} />;
      case 'essay':
        return (
          <EssayPage
            gotoNext={handleGoNext}
            onClickGoback={handleGoBack}
            data={lessonData}
            code={code}
            userData={userData}
            bookTitle={bookInfo?.book_lesson.title}
            userLessonIdx={state?.user_lesson_idx || null}
          />
        );
      default:
        return <ListPage onClickGoback={handleGoBack} />;
    }
  };

  const getBelowNavigator = (val) => {
    switch (val) {
      case 'voca':
        return (
          <Col span={24} className={`tail__section ${activeB ? 'active' : ''}`} style={{ padding: 0 }}>
            <div className="tail__layer" onClick={() => setActiveB(false)}></div>
            <div className={`tail__box ${activeB ? 'active' : ''}`}>
              <button type="button" className="tail__btn" deluminate_imagetype="png" onClick={() => setActiveB(!activeB)}></button>
              {activeB ? (
                <div className="section__inner">
                  <h3 className="tail__title">
                    <img src="/images/words.png" alt="voca" style={{ maxWidth: 500 }} />
                  </h3>
                  <ul className="tail__process">
                    <li
                      onClick={() => {
                        if (bookInfo.stage[0].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(1);
                        }
                      }}
                    >
                      <img className={`${indx === 1 ? 'active' : ''}`} src="/images/wordintro.png" alt="Intro" />
                    </li>
                    <li
                      onClick={() => {
                        if (bookInfo.stage[1].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(2);
                        }
                      }}
                    >
                      <img className={`${indx === 2 ? 'active' : ''}`} src="/images/wordpractice.png" alt="Intro" />
                    </li>
                    <li
                      onClick={() => {
                        if (bookInfo.stage[2].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(3);
                        }
                      }}
                    >
                      <img className={`${indx === 3 ? 'active' : ''}`} src="/images/wordtype.png" alt="Intro" />
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
          </Col>
        );
      case 'sentence':
        return (
          <Col span={24} className={`tail__section ${activeB ? 'active' : ''}`} style={{ padding: 0 }}>
            <div className="tail__layer" onClick={() => setActiveB(false)}></div>
            <div className={`tail__box ${activeB ? 'active' : ''}`}>
              <button type="button" className="tail__btn" deluminate_imagetype="png" onClick={() => setActiveB(!activeB)}></button>
              {activeB ? (
                <div className="section__inner">
                  <h3 className="tail__title">
                    <img src="/images/keysentences.png" alt="WORDS" style={{ maxWidth: 500 }} />
                  </h3>
                  <ul className="tail__process">
                    <li
                      onClick={() => {
                        if (bookInfo.stage[0].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(1);
                        }
                      }}
                    >
                      <img className={`${indx === 1 ? 'active' : ''}`} src="/images/keysentencesay.png" alt="Intro" />
                    </li>
                    <li
                      onClick={() => {
                        if (bookInfo.stage[1].is_complete || indx === bookInfo.stage.length) {
                          handleChangeIndx(2);
                        }
                      }}
                    >
                      <img className={`${indx === 2 ? 'active' : ''}`} src="/images/keysentencedictation.png" alt="Intro" />
                    </li>
                    {/* <li onClick={() => handleChangeIndx(3)}>
                      <img className={`${indx === 3 ? 'active' : ''}`} src="/images/keysentencespeak.png" alt="Intro" />
                    </li> */}
                    <li
                      onClick={() => {
                        if (bookInfo.stage[3].is_completev || indx === bookInfo.stage.length) {
                          handleChangeIndx(4);
                        }
                      }}
                    >
                      <img className={`${indx === 4 ? 'active' : ''}`} src="/images/keysentenceunscramble.png" alt="Intro" />
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
          </Col>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <Row gutter={[24, 16]}>
        {dataLoaded ? getSwitchableRoute(type) : null}
        {getBelowNavigator(type)}
      </Row>
    </>
  );
};

export default withRouter(Manage);
